// extracted by mini-css-extract-plugin
export default {"overlayLoader":"gRbmwX","message":"yieWln","icon":"zgiIu8"};